import { Box, Flex, Icon, IconButton } from "@chakra-ui/react"
import { Dispatch } from "react"
import { FaMinus, FaPlus } from "react-icons/fa"

const QuantitySelector = ({
  quantity,
  maxQuantity,
  setQuantity,
}: {
  quantity: number
  maxQuantity: number
  setQuantity: Dispatch<number>
}) => {
  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      width={"full"}
      position={"relative"}
    >
      <Box
        p={4}
        fontSize={"lg"}
        fontWeight={500}
        position={"absolute"}
        transform={"translateX(-100px)"}
      >
        {"Qty"}
      </Box>
      <IconButton
        aria-label={"Decrease quantity"}
        icon={<Icon as={FaMinus} />}
        onClick={() => setQuantity(-1)}
        isDisabled={quantity === 1}
      />
      <Box
        p={4}
        fontSize={"lg"}
        fontWeight={700}
      >
        {quantity}
      </Box>
      <IconButton
        aria-label={"Increase quantity"}
        icon={<Icon as={FaPlus} />}
        onClick={() => setQuantity(1)}
        isDisabled={quantity === maxQuantity}
      />
    </Flex>
  )
}

export default QuantitySelector
